const STORAGE_KEY = 'odyssey:recent-searches';
const MAX_RECENT_SEARCHES = 5;

/**
 * Reads the participant's recent global-search terms from local storage.
 */
export function getRecentSearches(): string[] {
    try {
        const raw = window.localStorage.getItem(STORAGE_KEY);
        if (!raw) return [];
        const parsed: unknown = JSON.parse(raw);
        if (!Array.isArray(parsed)) return [];
        return parsed.filter((entry): entry is string => typeof entry === 'string').slice(0, MAX_RECENT_SEARCHES);
    } catch {
        return [];
    }
}

/**
 * Stores a search term at the top of the recent list (case-insensitive dedupe).
 */
export function addRecentSearch(term: string): string[] {
    const trimmed = term.trim();
    if (!trimmed) return getRecentSearches();

    const existing = getRecentSearches().filter(
        (entry) => entry.toLowerCase() !== trimmed.toLowerCase(),
    );
    const updated = [trimmed, ...existing].slice(0, MAX_RECENT_SEARCHES);

    try {
        window.localStorage.setItem(STORAGE_KEY, JSON.stringify(updated));
    } catch {
        // Storage unavailable (private mode / quota) — recent searches are best-effort only.
    }
    return updated;
}
